// Keep the browser's one-shot install event outside LiveView's replaceable DOM.
export function setupPwaInstall(win = window, doc = document, analytics = null, store = null, now = Date.now) {
  let pendingPrompt = null
  let installed = false
  const standalone = win.matchMedia("(display-mode: standalone)")
  const displayMode = () => standalone.matches || win.navigator.standalone === true ? "standalone" : "browser"
  const ua = win.navigator.userAgent || ""
  const platform = /iPhone|iPad|iPod/.test(ua) || (/Macintosh/.test(ua) && win.navigator.maxTouchPoints > 1)
    ? "ios" : /Android/.test(ua) ? "android" : "other"
  const track = (event, data = {}) => analytics?.track(event, {platform, display_mode: displayMode(), ...data})
  let installReported = false
  const observeSession = () => {
    if (displayMode() !== "standalone" || doc.visibilityState === "hidden" || !analytics?.enabled() || !store) return
    const timestamp = now()
    const firstOpen = store.getItem("pwa:first-open:v1") === null
    const lastActive = Number(store.getItem("pwa:last-active:v1"))
    if (firstOpen) {
      track("pwa.first_open", {source: "standalone_observed"})
      store.setItem("pwa:first-open:v1", String(timestamp))
    }
    if (firstOpen || !lastActive || timestamp - lastActive >= 30 * 60 * 1000) {
      track("pwa.session_started", {first_open: firstOpen})
    }
    store.setItem("pwa:last-active:v1", String(timestamp))
  }
  const sync = () => {
    const runningInstalled = installed || standalone.matches || win.navigator.standalone === true
    doc.querySelectorAll("[data-pwa-entry]").forEach(el => { el.hidden = runningInstalled })
    doc.querySelectorAll("[data-pwa-install]").forEach(el => {
      el.hidden = runningInstalled || !pendingPrompt
      el.disabled = false
    })
    doc.querySelectorAll("[data-pwa-installed]").forEach(el => { el.hidden = !runningInstalled })
    doc.querySelectorAll("[data-pwa-help]").forEach(el => { el.hidden = runningInstalled })
  }
  win.addEventListener("beforeinstallprompt", event => {
    event.preventDefault()
    pendingPrompt = event
    sync()
  })
  win.addEventListener("appinstalled", () => {
    if (!installReported) {
      track("pwa.install_reported", {source: "appinstalled"})
      installReported = true
    }
    installed = true
    pendingPrompt = null
    sync()
  })
  standalone.addEventListener("change", () => { sync(); observeSession() })
  win.addEventListener("phx:page-loading-stop", observeSession)
  doc.addEventListener("visibilitychange", observeSession)
  doc.addEventListener("pointerdown", observeSession, {passive: true})
  doc.addEventListener("keydown", observeSession)
  win.addEventListener("phx:page-loading-stop", sync)
  doc.addEventListener("click", async event => {
    const button = event.target.closest?.("[data-pwa-install]")
    if (!button || !pendingPrompt) return
    const prompt = pendingPrompt
    pendingPrompt = null
    button.disabled = true
    track("pwa.install_clicked", {source: "in_app_button"})
    try {
      await prompt.prompt()
      const choice = await prompt.userChoice
      track("pwa.install_prompt_result", {outcome: choice.outcome, source: "in_app_button"})
      if (choice.outcome === "accepted") installed = true
    } catch {
      track("pwa.install_prompt_result", {outcome: "error", source: "in_app_button"})
      // A consumed or rejected prompt falls back to the browser-menu instructions.
    } finally {
      sync()
    }
  })
  sync()
  observeSession()
}
